module.exports = __webpack_public_path__ + "img/presentation_lobbyx.d4211d40.png";